import pick from 'lodash/pick';

import { types as sdkTypes, createImageVariantConfig } from '../../util/sdkLoader';
import { storableError } from '../../util/errors';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { transactionLineItems } from '../../util/api';
import * as log from '../../util/log';
import { denormalisedResponseEntities } from '../../util/data';
import { findNextBoundary, getStartOf, monthIdString } from '../../util/dates';
import {
  LISTING_PAGE_DRAFT_VARIANT,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
} from '../../util/urlHelpers';
import { getProcess, isBookingProcessAlias } from '../../transactions/transaction';
import { fetchCurrentUser, fetchCurrentUserHasOrdersSuccess } from '../../ducks/user.duck';

const { UUID } = sdkTypes;

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/ListingPage/SET_INITIAL_VALUES';

export const SHOW_LISTING_REQUEST = 'app/ListingPage/SHOW_LISTING_REQUEST';
export const SHOW_LISTING_ERROR = 'app/ListingPage/SHOW_LISTING_ERROR';

export const FETCH_REVIEWS_REQUEST = 'app/ListingPage/FETCH_REVIEWS_REQUEST';
export const FETCH_REVIEWS_SUCCESS = 'app/ListingPage/FETCH_REVIEWS_SUCCESS';
export const FETCH_REVIEWS_ERROR = 'app/ListingPage/FETCH_REVIEWS_ERROR';

export const FETCH_TIME_SLOTS_REQUEST = 'app/ListingPage/FETCH_TIME_SLOTS_REQUEST';
export const FETCH_TIME_SLOTS_SUCCESS = 'app/ListingPage/FETCH_TIME_SLOTS_SUCCESS';
export const FETCH_TIME_SLOTS_ERROR = 'app/ListingPage/FETCH_TIME_SLOTS_ERROR';

export const FETCH_LINE_ITEMS_REQUEST = 'app/ListingPage/FETCH_LINE_ITEMS_REQUEST';
export const FETCH_LINE_ITEMS_SUCCESS = 'app/ListingPage/FETCH_LINE_ITEMS_SUCCESS';
export const FETCH_LINE_ITEMS_ERROR = 'app/ListingPage/FETCH_LINE_ITEMS_ERROR';

export const SEND_INQUIRY_REQUEST = 'app/ListingPage/SEND_INQUIRY_REQUEST';
export const SEND_INQUIRY_SUCCESS = 'app/ListingPage/SEND_INQUIRY_SUCCESS';
export const SEND_INQUIRY_ERROR = 'app/ListingPage/SEND_INQUIRY_ERROR';

export const FETCH_SIMILAR_LISTINGS_REQUEST = 'app/ListingPage/FETCH_SIMILAR_LISTINGS_REQUEST';
export const FETCH_SIMILAR_LISTINGS_SUCCESS = 'app/ListingPage/FETCH_SIMILAR_LISTINGS_SUCCESS';
export const FETCH_SIMILAR_LISTINGS_ERROR = 'app/ListingPage/FETCH_SIMILAR_LISTINGS_ERROR';

export const FETCH_SIMILAR_CATEGORY_LISTINGS_REQUEST =
  'app/ListingPage/FETCH_SIMILAR_CATEGORY_LISTINGS_REQUEST';
export const FETCH_SIMILAR_CATEGORY_LISTINGS_SUCCESS =
  'app/ListingPage/FETCH_SIMILAR_CATEOGRY_LISTINGS_SUCCESS';
export const FETCH_SIMILAR_CATEGORY_LISTINGS_ERROR =
  'app/ListingPage/FETCH_SIMILAR_CATEGORY_LISTINGS_ERROR';

export const FETCH_FEATURED_SELLERS_REQUEST = 'app/ListingPage/FETCH_FEATURED_SELLERS_REQUEST';
export const FETCH_FEATURED_SELLERS_SUCCESS = 'app/ListingPage/FETCH_FEATURED_SELLERS_SUCCESS';
export const FETCH_FEATURED_SELLERS_ERROR = 'app/ListingPage/FETCH_FEATURED_SELLERS_ERROR';

export const FETCH_USER_LISTINGS_REQUEST = 'app/ListingPage/FETCH_USER_LISTINGS_REQUEST';
export const FETCH_USER_LISTINGS_SUCCESS = 'app/ListingPage/FETCH_USER_LISTINGS_SUCCESS';
export const FETCH_USER_LISTINGS_ERROR = 'app/ListingPage/FETCH_USER_LISTINGS_ERROR';

export const UPDATE_PHONE_REQUEST = 'app/user/UPDATE_PHONE_REQUEST';
export const UPDATE_PHONE_SUCCESS = 'app/user/UPDATE_PHONE_SUCCESS';
export const UPDATE_PHONE_ERROR = 'app/user/UPDATE_PHONE_ERROR';
// ================ Reducer ================ //

const initialState = {
  id: null,
  showListingError: null,
  reviews: [],
  fetchReviewsError: null,
  monthlyTimeSlots: {
    // '2022-03': {
    //   timeSlots: [],
    //   fetchTimeSlotsError: null,
    //   fetchTimeSlotsInProgress: null,
    // },
  },
  lineItems: null,
  fetchLineItemsInProgress: false,
  fetchLineItemsError: null,
  sendInquiryInProgress: false,
  sendInquiryError: null,
  inquiryModalOpenForListingId: null,
  similarListings: [],
  fetchSimilarListingsError: null,
  fetchSimilarListingsInProgress: false,
  similarCategoryListings: [],
  fetchSimilarCategoryListingsError: null,
  fetchSimilarCategoryListingsInProgress: false,
  featuredSellers: [],
  fetchFeaturedSellersError: null,
  fetchFeaturedSellersInProgress: false,
  phoneUpdateInProgress: false,
  phoneUpdateError: null,
};

const listingPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case SHOW_LISTING_REQUEST:
      return { ...state, id: payload.id, showListingError: null };
    case SHOW_LISTING_ERROR:
      return { ...state, showListingError: payload };

    case FETCH_REVIEWS_REQUEST:
      return { ...state, fetchReviewsError: null };
    case FETCH_REVIEWS_SUCCESS:
      return { ...state, reviews: payload };
    case FETCH_REVIEWS_ERROR:
      return { ...state, fetchReviewsError: payload };

    case FETCH_TIME_SLOTS_REQUEST: {
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [payload]: {
          ...state.monthlyTimeSlots[payload],
          fetchTimeSlotsError: null,
          fetchTimeSlotsInProgress: true,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_SUCCESS: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          timeSlots: payload.timeSlots,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_ERROR: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          fetchTimeSlotsError: payload.error,
        },
      };
      return { ...state, monthlyTimeSlots };
    }

    case FETCH_LINE_ITEMS_REQUEST:
      return { ...state, fetchLineItemsInProgress: true, fetchLineItemsError: null };
    case FETCH_LINE_ITEMS_SUCCESS:
      return { ...state, fetchLineItemsInProgress: false, lineItems: payload };
    case FETCH_LINE_ITEMS_ERROR:
      return { ...state, fetchLineItemsInProgress: false, fetchLineItemsError: payload };

    case SEND_INQUIRY_REQUEST:
      return { ...state, sendInquiryInProgress: true, sendInquiryError: null };
    case SEND_INQUIRY_SUCCESS:
      return { ...state, sendInquiryInProgress: false };
    case SEND_INQUIRY_ERROR:
      return { ...state, sendInquiryInProgress: false, sendInquiryError: payload };
    case FETCH_SIMILAR_LISTINGS_REQUEST:
      return { ...state, fetchSimilarListingsInProgress: true, fetchSimilarListingsError: null };
    case FETCH_SIMILAR_LISTINGS_SUCCESS:
      return { ...state, fetchSimilarListingsInProgress: false, similarListings: payload };
    case FETCH_SIMILAR_LISTINGS_ERROR:
      return {
        ...state,
        fetchSimilarListingsInProgress: false,
        fetchSimilarListingsError: payload,
      };
    case FETCH_SIMILAR_CATEGORY_LISTINGS_REQUEST:
      return {
        ...state,
        fetchSimilarCategoryListingsInProgress: true,
        fetchSimilarCategoryListingsError: null,
      };
    case FETCH_SIMILAR_CATEGORY_LISTINGS_SUCCESS:
      return {
        ...state,
        fetchSimilarCategoryListingsInProgress: false,
        similarCategoryListings: payload,
      };
    case FETCH_SIMILAR_CATEGORY_LISTINGS_ERROR:
      return {
        ...state,
        fetchSimilarCategoryListingsInProgress: false,
        fetchSimilarCategoryListingsError: payload,
      };

    case FETCH_FEATURED_SELLERS_REQUEST:
      return {
        ...state,
        fetchFeaturedSellersInProgress: true,
        fetchFeaturedSellersError: null,
      };
    case FETCH_FEATURED_SELLERS_SUCCESS:
      return {
        ...state,
        fetchFeaturedSellersInProgress: false,
        featuredSellers: payload,
      };
    case FETCH_FEATURED_SELLERS_ERROR:
      return {
        ...state,
        fetchFeaturedSellersInProgress: false,
        fetchFeaturedSellersError: payload,
      };
    case UPDATE_PHONE_REQUEST:
      return {
        ...state,
        phoneUpdateInProgress: true,
        phoneUpdateError: null,
      };
    case UPDATE_PHONE_SUCCESS:
      return {
        ...state,
        phoneUpdateInProgress: false,
      };
    case UPDATE_PHONE_ERROR:
      return {
        ...state,
        phoneUpdateInProgress: false,
        phoneUpdateError: payload,
      };
    default:
      return state;
  }
};

export default listingPageReducer;

// ================ Action creators ================ //

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

export const showListingRequest = id => ({
  type: SHOW_LISTING_REQUEST,
  payload: { id },
});

export const showListingError = e => ({
  type: SHOW_LISTING_ERROR,
  error: true,
  payload: e,
});

export const fetchReviewsRequest = () => ({ type: FETCH_REVIEWS_REQUEST });
export const fetchReviewsSuccess = reviews => ({ type: FETCH_REVIEWS_SUCCESS, payload: reviews });
export const fetchReviewsError = error => ({
  type: FETCH_REVIEWS_ERROR,
  error: true,
  payload: error,
});

export const fetchTimeSlotsRequest = monthId => ({
  type: FETCH_TIME_SLOTS_REQUEST,
  payload: monthId,
});
export const fetchTimeSlotsSuccess = (monthId, timeSlots) => ({
  type: FETCH_TIME_SLOTS_SUCCESS,
  payload: { timeSlots, monthId },
});
export const fetchTimeSlotsError = (monthId, error) => ({
  type: FETCH_TIME_SLOTS_ERROR,
  error: true,
  payload: { monthId, error },
});

export const fetchLineItemsRequest = () => ({ type: FETCH_LINE_ITEMS_REQUEST });
export const fetchLineItemsSuccess = lineItems => ({
  type: FETCH_LINE_ITEMS_SUCCESS,
  payload: lineItems,
});
export const fetchLineItemsError = error => ({
  type: FETCH_LINE_ITEMS_ERROR,
  error: true,
  payload: error,
});

export const sendInquiryRequest = () => ({ type: SEND_INQUIRY_REQUEST });
export const sendInquirySuccess = () => ({ type: SEND_INQUIRY_SUCCESS });
export const sendInquiryError = e => ({ type: SEND_INQUIRY_ERROR, error: true, payload: e });

export const fetchSimilarListingsRequest = () => ({ type: FETCH_SIMILAR_LISTINGS_REQUEST });
export const fetchSimilarListingsSuccess = listings => ({
  type: FETCH_SIMILAR_LISTINGS_SUCCESS,
  payload: listings,
});
export const fetchSimilarListingsError = error => ({
  type: FETCH_SIMILAR_LISTINGS_ERROR,
  error: true,
  payload: error,
});

export const fetchSimilarCategoryListingsRequest = () => ({
  type: FETCH_SIMILAR_CATEGORY_LISTINGS_REQUEST,
});
export const fetchSimilarCategoryListingsSuccess = listings => ({
  type: FETCH_SIMILAR_CATEGORY_LISTINGS_SUCCESS,
  payload: listings,
});
export const fetchSimilarCategoryListingsError = error => ({
  type: FETCH_SIMILAR_CATEGORY_LISTINGS_ERROR,
  error: true,
  payload: error,
});

export const fetchFeaturedSellersRequest = () => ({ type: FETCH_FEATURED_SELLERS_REQUEST });
export const fetchFeaturedSellersSuccess = sellers => ({
  type: FETCH_FEATURED_SELLERS_SUCCESS,
  payload: sellers,
});
export const fetchFeaturedSellersError = error => ({
  type: FETCH_FEATURED_SELLERS_ERROR,
  payload: error,
});

export const fetchUserListingsRequest = userId => ({
  type: FETCH_USER_LISTINGS_REQUEST,
  payload: userId,
});

export const fetchUserListingsSuccess = listings => ({
  type: FETCH_USER_LISTINGS_SUCCESS,
  payload: listings,
});

export const fetchUserListingsError = error => ({
  type: FETCH_USER_LISTINGS_ERROR,
  payload: error,
  error: true,
});

export const updatePhoneRequest = () => ({ type: UPDATE_PHONE_REQUEST });
export const updatePhoneSuccess = () => ({ type: UPDATE_PHONE_SUCCESS });
export const updatePhoneError = error => ({
  type: UPDATE_PHONE_ERROR,
  payload: error,
  error: true,
});

// ================ Thunks ================ //

export const showListing = (listingId, config, isOwn = false) => (dispatch, getState, sdk) => {
  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  dispatch(showListingRequest(listingId));
  dispatch(fetchCurrentUser());
  const params = {
    id: listingId,
    include: ['author', 'author.profileImage', 'images', 'currentStock'],
    'fields.image': [
      // Scaled variants for large images
      'variants.scaled-small',
      'variants.scaled-medium',
      'variants.scaled-large',
      'variants.scaled-xlarge',

      // Cropped variants for listing thumbnail images
      `variants.${variantPrefix}`,
      `variants.${variantPrefix}-2x`,
      `variants.${variantPrefix}-4x`,
      `variants.${variantPrefix}-6x`,

      // Social media
      'variants.facebook',
      'variants.twitter',

      // Avatars
      'variants.square-small',
      'variants.square-small2x',
    ],
    ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-4x`, 1600, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-6x`, 2400, aspectRatio),
  };

  const show = isOwn ? sdk.ownListings.show(params) : sdk.listings.show(params);

  return show
    .then(data => {
      const listingFields = config?.listing?.listingFields;
      const sanitizeConfig = { listingFields };
      dispatch(addMarketplaceEntities(data, sanitizeConfig));
      return data;
    })
    .catch(e => {
      dispatch(showListingError(storableError(e)));
    });
};

export const fetchSimilarListings = (listingTitle, excludeListingId, config) => (
  dispatch,
  getState,
  sdk
) => {
  dispatch(fetchSimilarListingsRequest());

  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  const params = {
    perPage: 16,
    include: ['images'],
    'fields.image': [
      `variants.square-small`,
      `variants.${variantPrefix}`,
      `variants.${variantPrefix}-2x`,
      `variants.${variantPrefix}-4x`,
      `variants.${variantPrefix}-6x`,
    ],
    ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-4x`, 1600, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-6x`, 2400, aspectRatio),
    keywords: listingTitle,
    meta_isHidden: false,
    pub_stripeConnected: true,
  };

  return sdk.listings
    .query(params)
    .then(response => {
      const listings = denormalisedResponseEntities(response);
      const similarListings = listings.slice(1, 16);
      dispatch(fetchSimilarListingsSuccess(similarListings));

      // dispatch(fetchSimilarListingsSuccess(listings));
    })
    .catch(e => {
      dispatch(fetchSimilarListingsError(storableError(e)));
    });
};

export const fetchSimilarCategoryListings = (listingCategory, excludeListingId, config) => (
  dispatch,
  getState,
  sdk
) => {
  dispatch(fetchSimilarCategoryListingsRequest());

  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  const params = {
    perPage: 15,
    include: ['images'],
    'fields.image': [
      `variants.square-small`,
      `variants.${variantPrefix}`,
      `variants.${variantPrefix}-2x`,
      `variants.${variantPrefix}-4x`,
      `variants.${variantPrefix}-6x`,
    ],
    ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-4x`, 1600, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-6x`, 2400, aspectRatio),
    pub_categorySingleSelect: listingCategory,
    meta_isHidden: false,
    pub_stripeConnected: true,
  };

  return sdk.listings
    .query(params)
    .then(response => {
      const listings = denormalisedResponseEntities(response);
      dispatch(fetchSimilarCategoryListingsSuccess(listings));
    })
    .catch(e => {
      dispatch(fetchSimilarCategoryListingsError(storableError(e)));
    });
};

export const queryUserListings = (userId, config) => (dispatch, getState, sdk) => {
  dispatch(fetchUserListingsRequest(userId));

  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  return sdk.listings
    .query({
      perPage: 10,
      author_id: userId,
      include: ['author', 'images'],
      'fields.image': [`variants.square-small`, `variants.${variantPrefix}`],
      ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
    })
    .then(response => {
      // Pick only the id and type properties from the response listings
      const listings = denormalisedResponseEntities(response);
      dispatch(fetchUserListingsSuccess(listings));
      return listings;
    })
    .catch(e => dispatch(fetchUserListingsError(storableError(e))));
};

export const fetchFeaturedSellers = (sellerIds, currentListingAuthorId, config) => (
  dispatch,
  getState,
  sdk
) => {
  dispatch(fetchFeaturedSellersRequest());

  const sellerPromises = sellerIds
    .filter(id => id !== currentListingAuthorId)
    .slice(0, 3)
    .map(sellerId =>
      Promise.all([
        sdk.users.show({
          id: new UUID(sellerId),
          include: ['profileImage'],
          'fields.image': ['variants.square-small', 'variants.square-small2x'],
        }),
        dispatch(queryUserListings(sellerId, config)),
      ])
    );

  return Promise.all(sellerPromises)
    .then(results => {
      let sellers;
      try {
        sellers = results.map(([user, listings]) => {
          const processedUser = denormalisedResponseEntities(user)[0];
          return {
            ...processedUser,
            listings: listings,
          };
        });
      } catch (error) {
        console.error('Error during mapping:', error);
      }

      dispatch(fetchFeaturedSellersSuccess(sellers));
    })
    .catch(error => dispatch(fetchFeaturedSellersError(storableError(error))));
};

export const fetchReviews = authorId => (dispatch, getState, sdk) => {
  dispatch(fetchReviewsRequest());
  return sdk.reviews
    .query({
      subjectId: authorId,
      state: 'public',
      include: ['author', 'author.profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    })
    .then(response => {
      const reviews = denormalisedResponseEntities(response);
      dispatch(fetchReviewsSuccess(reviews));
    })
    .catch(e => {
      dispatch(fetchReviewsError(storableError(e)));
    });
};

const timeSlotsRequest = params => (dispatch, getState, sdk) => {
  return sdk.timeslots.query(params).then(response => {
    return denormalisedResponseEntities(response);
  });
};

export const fetchTimeSlots = (listingId, start, end, timeZone) => (dispatch, getState, sdk) => {
  const monthId = monthIdString(start, timeZone);

  dispatch(fetchTimeSlotsRequest(monthId));

  // The maximum pagination page size for timeSlots is 500
  const extraParams = {
    perPage: 500,
    page: 1,
  };

  return dispatch(timeSlotsRequest({ listingId, start, end, ...extraParams }))
    .then(timeSlots => {
      dispatch(fetchTimeSlotsSuccess(monthId, timeSlots));
    })
    .catch(e => {
      dispatch(fetchTimeSlotsError(monthId, storableError(e)));
    });
};

export const sendInquiry = (listing, inquiryData) => async (dispatch, getState, sdk) => {
  const { message, images } = inquiryData;

  dispatch(sendInquiryRequest());
  const processAlias = listing?.attributes?.publicData?.transactionProcessAlias;
  if (!processAlias) {
    const error = new Error('No transaction process attached to listing');
    log.error(error, 'listing-process-missing', {
      listingId: listing?.id?.uuid,
    });
    dispatch(sendInquiryError(storableError(error)));
    return Promise.reject(error);
  }

  const listingId = listing?.id;
  const [processName, alias] = processAlias.split('/');
  const transitions = getProcess(processName)?.transitions;

  const bodyParams = {
    transition: transitions.INQUIRE,
    processAlias,
    params: { listingId },
  };

  try {
    // Initialize transaction
    const response = await sdk.transactions.initiate(bodyParams);
    const transactionId = response.data.data.id;

    // Array to hold all message promises
    const messagePromises = [];

    // 1. Send the text message if present
    if (message && message.trim()) {
      const textMessagePromise = sdk.messages.send({
        transactionId,
        content: message.trim(),
      });
      messagePromises.push(textMessagePromise);
    }

    // 2. Handle image upload if images are present
    if (Array.isArray(images) && images.length > 0) {
      const formData = new FormData();

      // Append each file to FormData
      images.forEach(file => formData.append('file-input', file));

      // Upload the images to the backend
      const uploadResponse = await fetch('/api/upload-endpoint', {
        method: 'POST',
        body: formData,
      });

      const uploadData = await uploadResponse.json();

      if (uploadResponse.ok) {
        // Send a message containing the uploaded image URLs
        const imageUrls = JSON.stringify(uploadData.data.urls); // Assuming the backend returns an array of image URLs
        const imageMessagePromise = sdk.messages.send({
          transactionId,
          content: imageUrls,
        });
        messagePromises.push(imageMessagePromise);
      } else {
        console.error('Image upload failed:', uploadData);
        throw new Error('Image upload failed');
      }
    }

    // 3. Wait for all messages (text and images) to be sent
    await Promise.all(messagePromises);

    // Dispatch success actions
    dispatch(sendInquirySuccess());
    dispatch(fetchCurrentUserHasOrdersSuccess(true));

    return transactionId;
  } catch (e) {
    dispatch(sendInquiryError(storableError(e)));
    throw e;
  }
};

// Helper function for loadData call.
const fetchMonthlyTimeSlots = (dispatch, listing) => {
  const hasWindow = typeof window !== 'undefined';
  const attributes = listing.attributes;
  // Listing could be ownListing entity too, so we just check if attributes key exists
  const hasTimeZone =
    attributes && attributes.availabilityPlan && attributes.availabilityPlan.timezone;

  // Fetch time-zones on client side only.
  if (hasWindow && listing.id && hasTimeZone) {
    const tz = listing.attributes.availabilityPlan.timezone;
    const unitType = attributes?.publicData?.unitType;
    const timeUnit = unitType === 'hour' ? 'hour' : 'day';
    const nextBoundary = findNextBoundary(new Date(), timeUnit, tz);

    const nextMonth = getStartOf(nextBoundary, 'month', tz, 1, 'months');
    const nextAfterNextMonth = getStartOf(nextMonth, 'month', tz, 1, 'months');

    return Promise.all([
      dispatch(fetchTimeSlots(listing.id, nextBoundary, nextMonth, tz)),
      dispatch(fetchTimeSlots(listing.id, nextMonth, nextAfterNextMonth, tz)),
    ]);
  }

  // By default return an empty array
  return Promise.all([]);
};

export const fetchTransactionLineItems = ({ orderData, listingId, isOwnListing }) => dispatch => {
  dispatch(fetchLineItemsRequest());
  transactionLineItems({ orderData, listingId, isOwnListing })
    .then(response => {
      const lineItems = response.data;
      dispatch(fetchLineItemsSuccess(lineItems));
    })
    .catch(e => {
      dispatch(fetchLineItemsError(storableError(e)));
      log.error(e, 'fetching-line-items-failed', {
        listingId: listingId.uuid,
        orderData,
      });
    });
};

export const updatePhoneNumber = phoneNumber => (dispatch, getState, sdk) => {
  dispatch(updatePhoneRequest());

  return sdk.currentUser
    .updateProfile(
      {
        protectedData: { phoneNumber },
      },
      {
        expand: true,
        include: ['profileImage'],
      }
    )
    .then(() => {
      dispatch(updatePhoneSuccess());
      dispatch(fetchCurrentUser());
    })
    .catch(e => {
      dispatch(updatePhoneError(storableError(e)));
      throw e;
    });
};

export const loadData = (params, search, config) => dispatch => {
  const listingId = new UUID(params.id);
  const sellerIds = [
    '6670620c-4f12-4eab-93f4-f381bba0522c',
    '666fc4ec-6a47-4295-8833-92cc148a13c5',
    '666f89a0-7f7c-4fe9-b4d4-7b984fb56ae4',
    '667b6efd-e74a-4bc1-93c8-0659e40e7b22',
  ];

  // Clear old line-items
  dispatch(setInitialValues({ lineItems: null }));

  const ownListingVariants = [LISTING_PAGE_DRAFT_VARIANT, LISTING_PAGE_PENDING_APPROVAL_VARIANT];
  if (ownListingVariants.includes(params.variant)) {
    return dispatch(showListing(listingId, config, true));
  }

  return Promise.all([dispatch(showListing(listingId, config))]).then(response => {
    const listing = response[0].data.data;
    const authorId = listing.relationships.author.data.id.uuid;
    const transactionProcessAlias = listing?.attributes?.publicData?.transactionProcessAlias || '';

    // Fetch reviews with authorId
    dispatch(fetchReviews(authorId));

    if (isBookingProcessAlias(transactionProcessAlias)) {
      // Fetch timeSlots.
      // This can happen parallel to loadData.
      // We are not interested to return them from loadData call.
      fetchMonthlyTimeSlots(dispatch, listing);
    }

    dispatch(fetchSimilarListings(listing.attributes.title, listingId, config));
    dispatch(
      fetchSimilarCategoryListings(
        listing.attributes.publicData.categorySingleSelect,
        listingId,
        config
      )
    );
    dispatch(fetchFeaturedSellers(sellerIds, listing.relationships.author.data.id.uuid, config));
    return response;
  });
};
